export default __webpack_public_path__ + "static/media/iPad-Pro.0d6ed226.png";